import { Button, Tooltip, Dropdown } from 'antd';
import classNames from 'classnames';
import { IconFont } from '../../../component/icon-font';
import { LockOutlined, UnlockOutlined, UpOutlined, CheckOutlined } from '@ant-design/icons';
import { SharePrivilege, ShareStatus } from '@zoom/videosdk';
import { getAntdDropdownMenu, getAntdItem } from './video-footer-utils';
import { Box, Button as ChakraButton, Menu, Portal } from '@chakra-ui/react';
import { FaChevronUp } from 'react-icons/fa';
import { useContext } from 'react';
import ZoomMediaContext from '../../../context/media-context';
import { isMobile } from '../../../utils/DeviceType';
import useLanguageSelector from '../../../hooks/useLanguageSelector';
const { Button: DropdownButton } = Dropdown;
interface ScreenShareButtonProps {
  sharePrivilege: SharePrivilege;
  isHostOrManager: boolean;
  onSharePrivilegeClick?: (privilege: SharePrivilege) => void;
  onScreenShareClick: () => void;
  isSharing: boolean;
}

interface ScreenShareLockButtonProps {
  isLockedScreenShare: boolean;
  onScreenShareLockClick: () => void;
}

const ScreenShareButton = (props: ScreenShareButtonProps) => {
  const LANG = useLanguageSelector();

  const { sharePrivilege, isHostOrManager, isSharing, onScreenShareClick, onSharePrivilegeClick } = props;
  const { mediaStream } = useContext(ZoomMediaContext);

  const menu = [
    getAntdItem(
      'Lock share',
      `${SharePrivilege.Locked}`,
      sharePrivilege === SharePrivilege.Locked && <CheckOutlined />
    ),
    getAntdItem(
      'One participant can share at a time',
      `${SharePrivilege.Unlocked}`,
      sharePrivilege === SharePrivilege.Unlocked && <CheckOutlined />
    ),
    getAntdItem(
      'Multiple participants can share simultaneously',
      `${SharePrivilege.MultipleShare}`,
      sharePrivilege === SharePrivilege.MultipleShare && <CheckOutlined />
    )
  ];
  const onMenuItemClick = (payload: { key: any }) => {
    onSharePrivilegeClick?.(Number(payload.key));
  };
  // return (
  //   <>
  //     <Box colorPalette={'blue'}>
  //       <ChakraButton borderRightRadius={'0'} marginRight={'0'} color={'#fff'} colorPalette={'blue'}>
  //         <IconFont type="icon-share" />
  //         画面共有
  //       </ChakraButton>
  //       <Menu.Root>
  //         <Menu.Trigger>
  //           <ChakraButton borderLeftRadius={'0'}>
  //             <FaChevronUp color={'#fff'} size={'10px'} />
  //           </ChakraButton>
  //         </Menu.Trigger>
  //         <Portal>
  //           <Menu.Positioner>
  //             <Menu.Content>
  //               <Menu.Item>New Text File</Menu.Item>
  //               <Menu.Item>New File...</Menu.Item>
  //               <Menu.Item>New Window</Menu.Item>
  //               <Menu.Item>Open File...</Menu.Item>
  //               <Menu.Item>Export</Menu.Item>
  //             </Menu.Content>
  //           </Menu.Positioner>
  //         </Portal>
  //       </Menu.Root>
  //       <ChakraButton borderLeftRadius={'0'}>
  //         <FaChevronUp color={'#fff'} size={'10px'} />
  //       </ChakraButton>
  //     </Box>
  //   </>
  // );
  return (
    <div className="screen-share-footer">
      {/* {isHostOrManager ? (
        <DropdownButton
          className={classNames('vc-dropdown-button', isSharing ? 'sharing' : '')}
          size="large"
          menu={getAntdDropdownMenu(menu, onMenuItemClick)}
          onClick={onScreenShareClick}
          trigger={['click']}
          type="ghost"
          icon={<UpOutlined />}
          placement="topRight"
          disabled={isSharing}
        >
          <IconFont type="icon-share" />
          {isMobile() || LANG.KT_0100_14}
        </DropdownButton>
      ) : ( */}
      <Button
        className={classNames('screen-share-button', 'vc-button', isSharing ? 'sharing' : '')}
        icon={<IconFont type="icon-share" />}
        ghost={true}
        shape="default"
        size="large"
        onClick={onScreenShareClick}
        disabled={isSharing}
      >
        {isMobile() || LANG.KT_0100_14}
      </Button>
      {/* )} */}
    </div>
  );
};

const ScreenShareLockButton = (props: ScreenShareLockButtonProps) => {
  const { isLockedScreenShare, onScreenShareLockClick } = props;
  return (
    <Tooltip title={isLockedScreenShare ? 'unlock screen share' : ' lock screen share'}>
      <Button
        className="screen-share-button"
        icon={isLockedScreenShare ? <LockOutlined /> : <UnlockOutlined />}
        // eslint-disable-next-line react/jsx-boolean-value
        ghost={true}
        shape="circle"
        size="large"
        onClick={onScreenShareLockClick}
      />
      <ChakraButton>{isLockedScreenShare ? <LockOutlined /> : <UnlockOutlined />}</ChakraButton>
    </Tooltip>
  );
};

export { ScreenShareButton, ScreenShareLockButton };
